import { render } from "./LeaveFormModal.vue?vue&type=template&id=a768efee&scoped=true"
import script from "./LeaveFormModal.vue?vue&type=script&lang=js"
export * from "./LeaveFormModal.vue?vue&type=script&lang=js"

import "./LeaveFormModal.vue?vue&type=style&index=0&id=a768efee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a768efee"]])

export default __exports__